export enum Platform {
  Unknown,
  Android,
  IOS,
}

export function definePlatform(): Platform {
  const userAgent = window.navigator.userAgent || window.navigator.vendor;

  if (/android/i.test(userAgent)) {
    return Platform.Android;
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return Platform.IOS;
  }

  return Platform.Unknown;
}
